import { render, staticRenderFns } from "./ParticipantSelf.vue?vue&type=template&id=381d9a88"
import script from "./ParticipantSelf.vue?vue&type=script&lang=js"
export * from "./ParticipantSelf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports